import { billingDollar } from "assets/icons";
import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";

const SubscriptionCardShrimmer = () => {
  return (
    <div className="billing_card">
      <div className="head">
        <div className="icon_wrap">
          <img src={billingDollar} alt="" />
          <img src={billingDollar} alt="" />
        </div>
      </div>
      <h4>{<SkeletonLoader type="text" height={28} width={50} />}</h4>
      <h5>{<SkeletonLoader type="text" height={24} width={200} />}</h5>

      {Array.from({ length: 4 }, (_, index) => (
        <p key={`${index}`}>
          {<SkeletonLoader type="text" height={20} width={150} />}
        </p>
      ))}
      <div className="button_wrap">
        <SkeletonLoader type="text" height={50} width={250} />
      </div>
    </div>
  );
};

export default SubscriptionCardShrimmer;
